import axios from 'axios';

const API_URL = 'http://127.0.0.1:8000';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Auth services
export const authService = {
    login: (credentials) => api.post('/api/login', credentials),
    register: (userData) => api.post('/api/register', userData),
    logout: () => api.post('/api/logout'),
};

// Profile services
export const profileService = {
    getProfile: () => api.get('/api/profile'),
    updateProfile: (data) => api.put('/api/profile', data),
};

// Request services
export const requestService = {
    getAllRequests: () => api.get('/api/requests'),
    getRequest: (id) => api.get(`/api/requests/${id}`),
    createRequest: (data) => api.post('/api/requests', data),
    updateRequest: (id, data) => api.put(`/api/requests/${id}`, data),
    deleteRequest: (id) => api.delete(`/api/requests/${id}`),
    getRecentRequests: (limit = 6) => api.get(`/api/student/recent-requests?limit=${limit}`),
};

// Academic records services
export const academicService = {
    getAllRecords: () => api.get('/api/academic-records'),
    getSemesterRecords: (semester) => api.get(`/api/academic-records/${semester}`),
};

// Student statistics service
export const studentStatsService = {
    async getStudentStats() {
        const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/';
        const { authFetch } = await import('./authFetch');
        const response = await authFetch(`${baseUrl}api/student/statistics`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });
        
        if (!response.ok) {
            throw new Error('Failed to fetch student statistics');
        }
        
        return response.json();
    }
};

// Error handler
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api; 